import { useMediaQuery } from "@mui/material";
import { fontFamilies } from "../../Utils/common";
import { FC, useContext, useState, useEffect } from "react";
import { ChooseYourFileButton, EditButton } from "../Custom/Buttons";

import appContext from "../../appContext";
import CustomizedInput from "../CreateForm/InputBase";
import CustomizedColorInput from "../CreateForm/ColorBase";
import CustomizedSingleSelectDropdown from "../CreateForm/DropdownBase";
import FileUploadDialog from "../CreateForm/DialogBase/FileUploadDialog";
import RadioButtonsGroup from "../FormSettings/OptionalComponents/RadioButtonsGroup";
import "./style.scss";

import {
  RootContainer,
  ColorSectionContainer,
  FontSectionContainer,
  FontTitleSectionContainer,
  ChooseYourFileButtonGrid,
  ColorTitleSectionContainer,
  ColorPropertiesContainer,
  ColorTextContainer,
  ColorDetailsContainer,
  ColorEditButtonContainer,
} from "./styled";

import {
  LandingPageSmallSpacingContainer,
  TextContainer,
} from "../FormSettings/OptionalComponents/styled";

type customCssProps = {
  editUUID: string;
  methods: any;
  dataFromModal: any;
  customKey: string;
  storeHistory: (field: string, value: any, type: string) => void;
};

const RadioButtonOptions = [
  { label: "Url", value: "url" },
  { label: "Upload an image", value: "upload" },
];

const CustomCss: FC<customCssProps> = ({
  editUUID,
  methods,
  dataFromModal,
  storeHistory,
}) => {
  const isLessThan1440 = useMediaQuery("(max-width:1439px)");
  const { uploadState, setuploadState } = useContext(appContext);

  const [bgRadio, setBgRadio] = useState("");
  const [filePopup, setFilePopup] = useState(false);
  const [colorPopup, setColorPopup] = useState(false);

  useEffect(() => {
    setBgRadio(uploadState ? "upload" : "url");
  }, [uploadState]);

  const handleOnUploadClose = (url: any) => {
    if (url) {
      methods.setValue("styles.background", url);
      setFilePopup(false);
    } else {
      setFilePopup(false);
    }
  };

  return (
    <RootContainer>
      <TextContainer>Background</TextContainer>
      <LandingPageSmallSpacingContainer>
        <RadioButtonsGroup
          dataProvider={RadioButtonOptions}
          value={bgRadio}
          setValue={(value: string) => {
            storeHistory("style.url.switch", uploadState, "formsettings");
            setuploadState(Boolean(value === "upload"));
          }}
        />
      </LandingPageSmallSpacingContainer>
      <LandingPageSmallSpacingContainer>
        <CustomizedInput
          placeholder={Boolean(bgRadio === "upload") ? "" : "Type URL"}
          value={methods.watch("styles.background")}
          onChange={(e: any) => {
            methods.setValue("styles.background", e.target.value);
          }}
        />
        {uploadState && (
          <ChooseYourFileButtonGrid item>
            <ChooseYourFileButton
              onClick={() => {
                setFilePopup(true);
              }}
            />
          </ChooseYourFileButtonGrid>
        )}
      </LandingPageSmallSpacingContainer>
      <FontSectionContainer isLargeScreen={!isLessThan1440}>
        <FontTitleSectionContainer isLargeScreen={!isLessThan1440}>
          Font
        </FontTitleSectionContainer>
        <CustomizedSingleSelectDropdown
          dataProvider={fontFamilies}
          value={methods.getValues("styles.fontFamily") || "Poppins"}
          setValue={(e: string) => {
            storeHistory(
              "styles.fontFamily",
              methods.getValues("styles.fontFamily") || "Poppins",
              "formsettings"
            );
            methods.setValue("styles.fontFamily", e);
          }}
        />
      </FontSectionContainer>
      <ColorSectionContainer isLargeScreen={!isLessThan1440}>
        <ColorTitleSectionContainer isLargeScreen={!isLessThan1440}>
          Color
        </ColorTitleSectionContainer>
        <ColorPropertiesContainer>
          <ColorDetailsContainer>
            <CustomizedColorInput
              open={colorPopup}
              closeHandler={() => {
                setColorPopup(false);
              }}
              color={
                methods.getValues("styles.color") || dataFromModal.textColor
              }
              setColor={(value: any) => {
                methods.setValue("styles.color", value);
              }}
            />
            <ColorTextContainer>
              {methods.getValues("styles.color") || dataFromModal.textColor}
            </ColorTextContainer>
          </ColorDetailsContainer>
          <ColorEditButtonContainer>
            <EditButton
              onClick={() => {
                setColorPopup(true);
              }}
            />
          </ColorEditButtonContainer>
        </ColorPropertiesContainer>
      </ColorSectionContainer>
      <FileUploadDialog
        open={filePopup}
        submitHandler={handleOnUploadClose}
        editUUID={editUUID}
      />
    </RootContainer>
  );
};

export default CustomCss;
